var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 1000 1000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M753.37639,246.62361a22.28077,22.28077,0,0,0-31.50526,0L500,468.49474,278.12887,246.62361a22.27758,22.27758,0,1,0-31.50526,31.50526L468.49474,500,246.62361,721.87113a22.27758,22.27758,0,0,0,31.50526,31.50526L500,531.50526,721.87113,753.37639a22.27758,22.27758,0,0,0,31.50526-31.50526L531.50526,500,753.37639,278.12887A22.27727,22.27727,0,0,0,753.37639,246.62361Z",
    id: "tagClose",
    fill: "#007F00",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagClose);
export default __webpack_public_path__ + "static/media/tagClose.2c68880476068f7b5a8b93a8b7ed7029.svg";
export { ForwardRef as ReactComponent };